import React, { Component } from 'react';
import { Line, Pie, Bar } from 'react-chartjs-2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import { Collapse } from 'react-collapse';
import Loader from 'react-loader-spinner';
import { ToastContainer, toast } from "react-toastify";

class DailyAksharUsageReport extends Component {
    constructor() {
        super();
        this.state = {
            selectedDate: new Date(),
            totalNoOfData: 0,
            displayConvByHour: true,
            displayConvByLang: true,
            displayConvBySourceType: true,
            displayConvByDomain: true,
            showLoader: false,
            displayChatHandle: true,

            convByHourData: {
                labels: [],
                datasets: [{
                    data: [],
                    label: "# of Akshar Usage",
                    borderColor: "#3BA4DC",
                    pointColor: "#fff",
                    responsive: true,
                    pointStrokeColor: "#ccc",
                    pointHoverRadius: 10,
                    backgroundColor: ["rgba(60,167,224,0.4)"],
                    fill: true
                }]
            },

            convByLanguage: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            'rgb(110, 125, 171)',
                            'rgb(156, 222, 159)',
                            'rgb(255, 102, 102)',
                            'rgb(14, 177, 210)',
                            'rgb(106, 57, 55)',
                            'rgb(204, 255, 102)',
                            'rgb(247, 160, 114)',
                            'rgb(191, 181, 175)',
                            'rgb(244, 255, 82)',
                            'rgb(95, 80, 107)',
                            'rgb(105, 255, 241)',
                            'rgb(155, 136, 22)',
                            'rgb(242, 100, 25)'
                        ]

                    }
                ]
            }
        }
    }

    componentDidMount() {
        var selectedDate = this.state.selectedDate;
        setTimeout(() => {
            this.fetchAksharUsageStatApi(selectedDate);
            this.fetchLanguageStatApi(selectedDate);
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            var selectedDate = thisController.state.selectedDate;
            thisController.projectId = event.projectId;
            thisController.fetchAksharUsageStatApi(selectedDate, event.projectId);
            thisController.fetchLanguageStatApi(selectedDate, event.projectId);
        });
    }

    NotifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    fetchAksharUsageStatApi = (selectedDate, projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var thisController = this;
        var longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/api/daily-analytics/akshar-usage-stat",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                date: longDate,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                thisController.state.convByHourData["datasets"][0].data = [];
                thisController.state.convByHourData["labels"] = [];
                if (res.success === true && res.result.length !== 0) {
                    var dataSetDataAndLabel = thisController.setDailyConvLabels(res.result);
                    thisController.state.convByHourData["datasets"][0].data = dataSetDataAndLabel.datasetData;
                    thisController.state.convByHourData["labels"] = dataSetDataAndLabel.labelData;

                    var totalNoOfData = 0
                    for (var i = 0; i < res.result.length; i++) {
                        var valueToInt = parseInt(res.result[i].value)
                        totalNoOfData += valueToInt;
                    }
                    thisController.state.totalNoOfData = totalNoOfData
                    thisController.state.showLoader = true;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    setDailyConvLabels = (data) => {
        var labelData = [];
        var datasetData = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].key < "12") {
                if (data[i].key == "00") {
                    labelData.push("12 AM - 1 AM");
                } else {
                    if (data[i].key == "11") {
                        labelData.push(Number(data[i].key) + " AM"
                            + " - " + (Number(data[i].key) + 1) + " PM");
                    } else {
                        labelData.push(Number(data[i].key) + " AM"
                            + " - " + (Number(data[i].key) + 1) + " AM");
                    }
                }
            } else {
                if (data[i].key == "12") {
                    labelData.push(Number(data[i].key) + " PM"
                        + " - " + ((Number(data[i].key) - 12) + 1) + " PM");
                } else {
                    if (data[i].key == "23") {
                        labelData.push((Number(data[i].key) - 12) + " PM"
                            + " - " + ((Number(data[i].key) - 12) + 1) + " AM");
                    } else {
                        labelData.push((Number(data[i].key) - 12) + " PM"
                            + " - " + ((Number(data[i].key) - 12) + 1) + " PM");
                    }
                }
            }
            datasetData.push(data[i].value);
        }
        return { "datasetData": datasetData, "labelData": labelData };

    }

    fetchLanguageStatApi = (selectedDate, projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var thisController = this;
        var longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/api/daily-analytics/akshar-language-stat",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                date: longDate,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                thisController.state.convByLanguage.labels = [];
                thisController.state.convByLanguage.datasets[0].data = [];
                if (res.success === true && res.result.length !== 0) {
                    for (var i = 0; i < res.result.length; i++) {
                        thisController.state.convByLanguage.labels.push(res.result[i].key);
                        thisController.state.convByLanguage.datasets[0].data.push(res.result[i].value);
                    }
                    thisController.state.showLoader = true;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    onDateChange = (date) => {
        this.state.selectedDate = date;
        this.setState(this.state);
        this.fetchAksharUsageStatApi(date);
        this.fetchLanguageStatApi(date);
    }

    refreshData = (id) => {
        var longDate = this.state.selectedDate;
        var thisController = this
        thisController = this.state.editedId = id;
        this.fetchAksharUsageStatApi(longDate);
        this.fetchLanguageStatApi(longDate);
    }

    resetDate = () => {
        this.onDateChange(new Date());
    }

    displayConvByHour = () => {
        this.state.displayConvByHour ? this.setState({ displayConvByHour: false }) :
            this.setState({ displayConvByHour: true });
    }

    displayConvByLang = () => {
        this.state.displayConvByLang ? this.setState({ displayConvByLang: false }) :
            this.setState({ displayConvByLang: true });
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(true)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} />
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <div style={{ display: 'block' }}>

                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-7">
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '10px', marginLeft: '7px' }}>Daily Akshar Usage Data</h6>
                            </div>

                            <ToastContainer className="Toast-at-center" />

                            <div className="col-sm-5 p-0">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <button className="btn action-button"
                                        style={{ marginTop: '0px' }}
                                        onClick={this.refreshData} title="Refresh">
                                        <img src="./assets/images/refresh_white_24dp.png" />
                                    </button>

                                    <button className="btn action-button"
                                        style={{ marginTop: '0px' }}
                                        onClick={this.resetDate}>Reset</button>

                                    <DatePicker
                                        id="date"
                                        selected={this.state.selectedDate}
                                        onChange={this.onDateChange}>
                                    </DatePicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: "8px" }}>
                        <h6>
                            <img src={this.state.displayConvByHour ? './assets/images/downward_arrow.png' :
                                './assets/images/rightward_arrow.png'}
                                onClick={this.displayConvByHour} />Akshar Usage by Hour<br /><br />
                            <label>Total No Of Akshar Usage : {this.state.totalNoOfData}</label></h6>
                        <div className="col-lg-12">
                            <Collapse isOpened={this.state.displayConvByHour}>

                                <div className="card filled-line-chart">
                                    <div className="card-body">
                                        <div className="position-relative mb-4">
                                            <Line data={this.state.convByHourData} width={1000} height={200} />

                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        <div className="col-lg-12">
                            <h6>
                                <img src={this.state.displayConvByLang ? './assets/images/downward_arrow.png' :
                                    './assets/images/rightward_arrow.png'}
                                    onClick={this.displayConvByLang} />Akshar Usage by Language</h6><br />
                            <Collapse isOpened={this.state.displayConvByLang}>
                                <div className="col-lg-3" />
                                <div className="col-lg-6">
                                    <div className="card monthly-conversation-chart">
                                        <div className="card-body">
                                            <div className="chartHeight">
                                                <Pie data={this.state.convByLanguage} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* /.card */}
                                </div>
                                <div className="col-lg-3" />
                            </Collapse>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DailyAksharUsageReport;



// WEBPACK FOOTER //
// ./src/aksharUi/reports/DailyAksharUsageReport.js